// Import necessary types and constants
import axios from 'axios';
import { Dispatch } from 'redux';
import { CmsEntry, CmsData } from "@/data/types";

// Define action type constant
export const GET_CMS_ENTRY_DATA = 'GET_CMS_ENTRY_DATA';

// Define the action interface
interface GetCmsEntryDataAction {
  type: typeof GET_CMS_ENTRY_DATA;
  payload: CmsEntry[]; // Assuming your payload is an array of CmsEntry
}

// Define the state interface
interface CmsEntryDataState {
  cmsEntryData: CmsEntry[] | null; // State is either an array of CmsEntry or null
}

// Initial State
const initialState: CmsEntryDataState = {
  cmsEntryData: null,
};

// Action creator function
export const getCmsEntryData = (content_cms: string, language: string) => async (dispatch: Dispatch<GetCmsEntryDataAction>) => {
  try {
    const response = await axios.get<CmsEntry[]>(`${process.env.NEXT_PUBLIC_SOCKET}/api/cms/entry/dataByCmsAndLanguage`, {
      params: { content_cms, language }
    });

    if (response.data) {
      // Sort the entire cmsEntryData array by id in ascending order
      const sortedCmsEntryData = response.data.sort((a: CmsEntry, b: CmsEntry) => a.id - b.id);

      // Sort each 'data' array within the sortedCmsEntryData
      const sortedDataEntries = sortedCmsEntryData.map((entry: CmsEntry) => ({
        ...entry,
        data: entry.data.sort((a: CmsData, b: CmsData) => a.id - b.id),
      }));

      dispatch({
        type: GET_CMS_ENTRY_DATA,
        payload: sortedDataEntries,
      });
    } else {
      // Handle the case when data is not available
      console.warn('No data available');
    }
  } catch (error) {
    console.error('Error fetching CMS entry data:', error);
    // Handle the error case, e.g., dispatch an error action if needed
  }
};

// Reducer function
const cmsEntryDataReducer = (
  state: CmsEntryDataState = initialState,
  action: GetCmsEntryDataAction
): CmsEntryDataState => {
  switch (action.type) {
    case GET_CMS_ENTRY_DATA:
      return {
        ...state,
        cmsEntryData: action.payload, // Assuming payload is always an array
      };
    default:
      return state;
  }
};

export default cmsEntryDataReducer;
